var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ControlOption',{attrs:{"campos":_vm.campos,"camposIndex":_vm.camposIndex}},[_c('v-text-field',{attrs:{"disabled":"","prepend-icon":"fas fa-at","label":_vm.campos.pregunta + (_vm.campos.obligatorio== 1 ? '  **' : '')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }